module.exports = __webpack_public_path__ + "static/default-0209d72d0571e97049cd7827681c146d.jpg";